import { useState, useEffect, useCallback } from 'react';
import { fardoService, distribucionFardoService } from '../services/supabase';

export function useFardos(usuarioId, campoId) {
  const [fardos, setFardos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Cargar fardos
  const loadFardos = useCallback(async () => {
    if (!usuarioId || !campoId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await fardoService.getAll(usuarioId, campoId);
      setFardos(data || []);
    } catch (e) {
      setError(e.message);
      console.error('Error cargando fardos:', e);
    } finally {
      setLoading(false);
    }
  }, [usuarioId, campoId]);

  // Auto-cargar
  useEffect(() => {
    loadFardos();
  }, [loadFardos]);

  // Crear fardo
  const createFardo = useCallback(async (fardo) => {
    if (!usuarioId || !campoId) throw new Error("usuarioId y campoId requeridos");
    try {
      const saved = await fardoService.create(usuarioId, campoId, fardo);
      setFardos(prev => [...prev, saved]);
      return saved;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, [usuarioId, campoId]);

  // Actualizar fardo
  const updateFardo = useCallback(async (fardoId, updates) => {
    try {
      const updated = await fardoService.update(fardoId, updates);
      setFardos(prev => prev.map(f => f.id === fardoId ? updated : f));
      return updated;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  // Eliminar fardo
  const deleteFardo = useCallback(async (fardoId) => {
    try {
      await fardoService.delete(fardoId);
      setFardos(prev => prev.filter(f => f.id !== fardoId));
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  return {
    fardos,
    setFardos,
    loading,
    error,
    loadFardos,
    createFardo,
    updateFardo,
    deleteFardo,
  };
}
